var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container mr-logs-container" },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-position": "top",
            "label-width": "8em",
            inline: true,
            size: "mini",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", gutter: 8 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 8 } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "w-100" },
                    [
                      _c("el-date-picker", {
                        staticClass: "w-100",
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          clearable: false,
                          "start-placeholder": _vm.$t("dateRange.startDate"),
                          "end-placeholder": _vm.$t("dateRange.endDate"),
                          "picker-options": { firstDayOfWeek: 7 },
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 4 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            clearable: "",
                            placeholder: _vm.$t("planning.alertType"),
                          },
                          model: {
                            value: _vm.alertType,
                            callback: function ($$v) {
                              _vm.alertType = $$v
                            },
                            expression: "alertType",
                          },
                        },
                        _vm._l(["normal", "yellow", "red"], function (item) {
                          return _c("el-option", {
                            key: item,
                            attrs: {
                              label: _vm.$t("general." + item),
                              value: item,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 4 } },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.showAll,
                        callback: function ($$v) {
                          _vm.showAll = $$v
                        },
                        expression: "showAll",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("general.showAll")))]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 8 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.getData("data")
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon: "search",
                              "aria-hidden": "true",
                              size: "sm",
                            },
                          }),
                          _c("span", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(_vm.$t("general.search"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "settings" },
            [
              _c("el-pagination", {
                staticClass: "mt-2 mb-2",
                attrs: {
                  background: "",
                  layout: "sizes, total, prev, pager, next",
                  "current-page": _vm.pagination["currentPage"],
                  "page-size": _vm.pagination["pageSize"],
                  "page-sizes": [10, 20, 30, 50, 100],
                  total: _vm.pagination["totalData"],
                },
                on: {
                  "size-change": function ($event) {
                    return _vm.handlePagination($event, "sizeChange")
                  },
                  "current-change": function ($event) {
                    return _vm.handlePagination($event, "currentChange")
                  },
                },
              }),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.data,
                    height: 700,
                    border: "",
                    "cell-class-name": _vm.tableClassName,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", width: "50" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "message",
                      label: _vm.$t("general.event"),
                      width: "150",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.logType === "NORMAL"
                                ? [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "truck-moving" },
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("general.normal")) +
                                        " "
                                    ),
                                  ]
                                : _vm._e(),
                              scope.row.logType === "YELLOW"
                                ? [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "clock" },
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("general.alert")) +
                                        " "
                                    ),
                                  ]
                                : _vm._e(),
                              scope.row.logType === "RED"
                                ? [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "exclamation-triangle" },
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("general.delay")) +
                                        " "
                                    ),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1123794787
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "message",
                      label: _vm.$t("general.details"),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.data
                                ? [
                                    scope.row.data.projectCode
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.helper
                                                .uniq(
                                                  scope.row.data.projectCode
                                                )
                                                .join(", ")
                                            ) + " -"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.data.shipmentReference.join(
                                            ", "
                                          )
                                        )
                                      ),
                                    ]),
                                    scope.row.data.companyName
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.helper
                                                  .uniq(
                                                    scope.row.data.companyName
                                                  )
                                                  .join(", ")
                                              ) +
                                              " -"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.getStatusLogs(scope.row)) +
                                        " - [" +
                                        _vm._s(_vm.$t("general.driver")) +
                                        ": " +
                                        _vm._s(scope.row.data.driverName) +
                                        "] "
                                    ),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1520657330
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "message",
                      label: _vm.$t("general.timestamp"),
                      width: "200",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.helper.dateToString(
                                      new Date(scope.row.createdAt)
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      426538258
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }